/* refactored - ali */
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

export const PortalCard = ({ portal, project, clone, goToPortal }) => {

    const cloneButton = useRef(null);

    const { t } = useTranslation([
        "portal/common",
    ], {
        useSuspense: false
    })

    function handleClone(e) {
        e.preventDefault();
        clone(portal);
    }

    function handleCardClick(e) {
        if (cloneButton && cloneButton.current && cloneButton.current.contains(e.target)) {
            handleClone();
        } else {
            goToPortal(portal);
        }
    }

    return (
        <div className="mb-4 col-md-6 col-xl-4 cursor-pointer" onClick={handleCardClick}>
            <div className="border card">
                <div className="p-3">
                    <span className="p-4"
                    >
                        {portal.Icon ? (
                            <i style={{ background: portal.IconColor }} className={`${portal.Icon} t-white portal-icon`}></i>
                        ) : (
                            portal.portalName.charAt(0).toUpperCase()
                        )}
                    </span>
                    <div className="card-header-text mb-4">
                        <span className="one-line-truncate pointer t-primary bigger me-2">{portal.portalName}</span>
                        {!portal.isActive && (
                            <span className="me-2 pointer">
                                <i className="fas fa-ban font-weight-bold text-danger blink"></i>
                            </span>
                        )}
                    </div>
                    <div className="two-line-truncate text-2 font-size-1">
                        {portal.portalDescription}
                    </div>
                </div>
                <div className="border-top d-flex justify-content-between align-items-center">
                    <span className="py-2 ms-3">
                        <span className="d-block text-3 font-size-1">
                            {t("portal_card.updated_on")}
                        </span>
                        <span className="bold">
                            {new Date(portal.updatedDate).toLocaleString()}
                        </span>
                    </span>
                    {/* <div className="p-3">
                        {
                            project.developerMode &&
                            <button
                                className="btn btn-secondary"
                                onClick={handleClone}
                                title="Clone Portal"
                                ref={cloneButton}
                            >
                                <i className="mx-2 fal fa-clone icon"></i>
                                {t("portal_card.buttons.clone_portal_button_label")}
                            </button>
                        }
                    </div> */}
                </div>
            </div>
        </div>
    );
};
